import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/FocusWithin/FocusWithinUsage.mdx";

import Examples from "../../Docs/Components/FocusWithin/FocusWithinExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="FocusWithin"
            description="Update your component styles or layout using a focus within component."
            apiSources={["azure-devops-ui/Components/FocusWithin/FocusWithin.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;